import Header from './header';

const headerConfig = {
  name: 'siteHeader',
  class: Header,
  querySelector: {
    open: '.menu-open',
    close: '.menu-close',
    dialog: '.main-navigation',
  },
  querySelectorAll: {
    menuParents: '.menu-item-has-children:not(.sub-menu .menu-item-has-children)',
    menuButtons: '.menu-item button',
    focusTraps: '.focus-trap',
  },
  options: {},
};

export default headerConfig;
